"use client";
import { useState } from "react";
const faqs = [
    {
        question: "What is Pediatric Nephrology?",
        answer: "Pediatric Nephrology is a medical specialty that focuses on diagnosing and treating kidney-related diseases in infants, children, and adolescents.",
    },
    {
        question: "When should I take my child to a pediatric nephrologist in Patna?",
        answer: "You should consult a specialist if your child has symptoms like swelling, blood in urine, frequent infections, or abnormal urination patterns.",
    },
    {
        question: "What are the common kidney diseases in children?",
        answer: "Common conditions include nephrotic syndrome, urinary tract infections (UTIs), kidney stones, acute kidney injury, and chronic kidney disease.",
    },
    {
        question: "Is kidney disease in children curable?",
        answer: "Many kidney conditions in children are treatable if diagnosed early. Some chronic conditions require long-term management but can be controlled effectively.",
    },
    {
        question: "What tests are done to diagnose kidney problems in children?",
        answer: "Doctors may recommend blood tests, urine tests, ultrasound imaging, and in some cases, a kidney biopsy for accurate diagnosis.",
    },
    {
        question: "Is dialysis safe for children?",
        answer: "Yes, pediatric dialysis is safe when performed under expert supervision. It helps manage kidney failure and supports overall health.",
    },
    {
        question: "What is the difference between adult and pediatric nephrology?",
        answer: "Children require specialized care because their bodies are still developing, and kidney diseases can affect growth and development differently than in adults.",
    },
    {
        question: "Can children undergo kidney transplant?",
        answer: "Yes, kidney transplants can be successfully performed in children, with proper evaluation and post-transplant care.",
    },
    {
        question: "How can I keep my child’s kidneys healthy?",
        answer: "Ensure proper hydration, balanced diet, timely treatment of infections, and regular health checkups to maintain kidney health.",
    },
    {
        question: "Why choose HDNA Aarogyam Hospital for pediatric nephrology in Patna?",
        answer: "HDNA Aarogyam offers expert specialists, advanced technology, child-friendly care, and comprehensive treatment under one roof.",
    },
]
export default function FaqSection() {
    const [activeIndex, setActiveIndex] = useState(null);
    const leftFaqs = faqs.slice(0, 5);
    const rightFaqs = faqs.slice(5, 10);
    const toggleFaq = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const renderFaqs = (faqList, offset) =>
        faqList.map((faq, index) => {
            const currentIndex = index + offset;
            return (
                <div key={currentIndex} className="faq-box" onClick={() => toggleFaq(currentIndex)} >
                    {/* Question */}
                    <div className={`faq-question ${activeIndex === currentIndex ? "active" : ""}`}>
                        <h6>{faq.question}</h6>
                        <span className="icon"> {activeIndex === currentIndex ? "−" : "+"}</span>
                    </div>
                    {/* Answer */}
                    {activeIndex === currentIndex && (
                        <div className="faq-answer"> <p>{faq.answer}</p> </div>
                    )}
                </div>
            );
        });

    return (
        <section className="faq-section container">
            <div className="row">
                {/* Left Column */}
                <div className="col-lg-6">{renderFaqs(leftFaqs, 0)}</div>
                {/* Right Column */}
                <div className="col-lg-6">{renderFaqs(rightFaqs, 5)}</div>
            </div>
        </section>
    );
}
